import React, {useState, useEffect, useContext} from 'react';
import styled from "styled-components";

import { PaymentContext } from "../../utils/paymentConfigProvider";

import LoginButtonsComponent from '../desktop/CardComponents/LoginButtonsComponent';
import ConfirmStreamPowerBuyModalComponent from './ConfirmStreamPowerBuyModalComponent';

import eventBus from '../../utils/globalPubSub';

import { getLoginInformation,
         getPaymentInformation
} from '../../utils/loginHelper';

import { Bars } from "react-loader-spinner";

import { buyPowerIndia } from '../../utils/perksUtils';
import {initializeRazorpay} from '../../utils/paymentHelpers';

const GradientButton = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  color: #FFFFFF;
  padding: 10px;
  background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
  border-radius: 12px;
`;


export default function BuyStreamPowerComponent(props:any) {
    const [piAvailable, setPiAvailable] = useState(false);
    const [user, setUser] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    
    const [indianBuyLoader, setIndianBuyLoader] = useState(false);
    


    const paymentConfig:any = useContext(PaymentContext);
    console.log('paymentConfig', paymentConfig);
    const checkIsIndiaPayment = (paymentConfig)=>{
        if(!paymentConfig){
            return false;
        }
        if(!paymentConfig.creatorConfig){
            return false
        }
        if(paymentConfig.creatorConfig.config.acceptedCurrencies.includes('INR')){
            return true;
        }
    }
    const isIndiaPayment = checkIsIndiaPayment(paymentConfig);

    let currencyString ='$';
    if(isIndiaPayment){
        currencyString = `\u20B9`;
    }
    
    useEffect(()=>{
        if(getPaymentInformation()){
            setPiAvailable(true)
        }
        else{
        }
    },[]);

    useEffect(()=>{
        eventBus.on('payment-details-changed', (pd)=>{
            if(pd){setPiAvailable(true)}
            else{setPiAvailable(false)}
        })
        return () => {
            eventBus.remove('payment-details-changed');
        }
    });

        
    const handleLogin = async (loginDetails)=>{
        setUser(loginDetails.user);        
    }

    const handleLogout = ()=> {setUser({});}

    useEffect(() => {
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        });
        return () => {
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    }, []);

    
    const buyPower = async () => {
        if(isIndiaPayment){
            setIndianBuyLoader(true);
            let directUserPerkOrder = await buyPowerIndia(
                props.power.id, props.creatorName,
                
            );
            if(directUserPerkOrder){
                initializeRazorpay(
                    props.power.value,
                    directUserPerkOrder.data.order.id,
                    paymentConfig,
                    (err)=>{
                        //setError(err);
                        //setTimeout(()=>{setError('')}, 5000);
                    },
                    () => {
                        //setSuccess(true);
                        eventBus.dispatch("success-perk-buy");
                });
            }
            setIndianBuyLoader(false);
            return;
        }
        if(!getPaymentInformation()){
            eventBus.dispatch('open-payment-information');
            return;
        }
        setIsOpen(true)
    }
    
    return (
        <>
            <ConfirmStreamPowerBuyModalComponent
                isOpen={isOpen}
                handleModalCloseEvent={()=> {setIsOpen(false)}}
                power={props.power}
                creatorName={props.creatorName}
            >
            </ConfirmStreamPowerBuyModalComponent>
            {(Object.keys(user).length===0) && (
                <div style={{marginTop:16}}>
                    <LoginButtonsComponent>
                    </LoginButtonsComponent>
                </div>
            )}
            {(Object.keys(user).length>0) && (
                <GradientButton
                    onClick={()=>{buyPower();} }
                    className='hover'>
                    {!indianBuyLoader && (<>
                        BUY POWER {currencyString} {props.power.data.price}
                    </>)}
                    {indianBuyLoader && (<>
                        <Bars height="30" width="30"
                              color="grey"
                              arialLabel="loading-indicator" />
                    </>)}
                </GradientButton>
            )}
        </>
    );
}
